import { Instagram, Facebook, Youtube } from "lucide-react";

// Clean inline SVG for X (formerly Twitter) — matches lucide stroke/size conventions.
const XIcon = ({ size = 17 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.451-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644z" />
  </svg>
);

// Clean inline SVG for LinkedIn.
const LinkedInIcon = ({ size = 17 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z" />
  </svg>
);

// IndiaMART — official brand logo/favicon asset.
const IndiaMartIcon = ({ size = 17 }) => (
  <img
    src="/indiamart-logo.png"
    alt="IndiaMART"
    width={size + 3}
    height={size + 3}
    loading="lazy"
    className="rounded-[4px] object-contain"
    style={{ width: size + 3, height: size + 3 }}
  />
);

// Single source of truth for official social links. Add Amazon/Flipkart here later
// (e.g. { label: "Amazon", href, Icon }) and they appear everywhere automatically.
export const SOCIAL_LINKS = [
  { label: "Instagram", href: "https://www.instagram.com/autocarexindia/", Icon: Instagram },
  { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61590869154174", Icon: Facebook },
  { label: "YouTube", href: "https://www.youtube.com/@AutoCareXIndia", Icon: Youtube },
  { label: "X (Twitter)", href: "https://x.com/care_x90888", Icon: XIcon },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/autocarex/", Icon: LinkedInIcon },
  { label: "IndiaMART", href: "https://www.indiamart.com/jtmaxindiaenterprises", Icon: IndiaMartIcon },
];

/**
 * Reusable site-wide social links row. Used in the Footer and Contact page.
 * @param {string} className - wrapper classes
 * @param {number} iconSize - icon size in px
 */
export const SocialLinks = ({ className = "", iconSize = 17 }) => (
  <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="social-links">
    {SOCIAL_LINKS.map(({ label, href, Icon }) => (
      <a
        key={label}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        title={label}
        data-testid={`social-link-${label.split(" ")[0].toLowerCase()}`}
        className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-[color:var(--acx-border)] bg-white/5 text-white/75 transition-colors hover:bg-white/10 hover:text-white"
      >
        <Icon size={iconSize} />
      </a>
    ))}
  </div>
);

export default SocialLinks;
